import { IMPORT_HISTORY_TYPE } from 'api/import_history/constants'

import { ImportHistory } from 'components/common'

export const DailyReportHistory = () => {
  return <ImportHistory importHistoryType={IMPORT_HISTORY_TYPE.DAILY_REPORT} />
}
